<template>
  <v-dialog persistent v-model="openReportProfileModel" max-width="400">
    <v-card>
      <v-card-title class="gc-text-h6">{{
        lang.reports.ProfileReport
      }}</v-card-title>
      <v-card-text>{{ lang.reports.AreProfile }}</v-card-text>
      <v-card-text>
        <div class="input-group" style="width: 100%">
          <label>{{ lang.reports.ReportReason }} *</label>
          <select v-model="reportReason" class="custom-select">
            <option
              v-for="(report, ind) in reportProfileItems"
              :key="ind"
              :value="report.value"
            >
              {{ report.text }}
            </option>
          </select>
        </div>
        <div class="input-group mt-3" v-if="reportReason == 'Other'">
          <label>{{ lang.reports.OtherReason }} *</label>
          <textarea v-model="reportOther" rows="4"></textarea>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeReportProfile()"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn small class="ml-2 btn-bg" elevation="0" @click="reportProfile()">
          {{ lang.actions.report }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReportProfileDialog",
  data() {
    return {
      reportReason: "",
      reportOther: "",
    };
  },
  props: {
    openReportProfileModel: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["rules"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    reportProfileItems() {
      return [
        {
          text: this.lang.reports.Reasons.alreadyExist,
          value: "Profile already exists",
        },
        {
          text: this.lang.reports.Reasons.fakeData,
          value: "Fake data",
        },
        {
          text: this.lang.reports.Reasons.notDeceased,
          value: "Not deceased",
        },
        {
          text: this.lang.reports.Reasons.unauthorizedMemorialization,
          value: "Unauthorized memorialization",
        },
        {
          text: this.lang.reports.Reasons.inappropriateContent,
          value: "Inappropriate content",
        },
        {
          text: this.lang.reports.Reasons.privacyConcerns,
          value: "Privacy concerns",
        },
        {
          text: this.lang.reports.Reasons.requestForRemoval,
          value: "Request for removal",
        },
        {
          text: this.lang.reports.Reasons.other,
          value: "Other",
        },
      ];
    },
  },
  methods: {
    reportProfile() {
      if (
        (this.reportReason &&
          this.reportReason == "Other" &&
          this.reportOther) ||
        (this.reportReason && this.reportReason != "Other")
      ) {
        this.$emit("reportProfile", this.reportReason, this.reportOther);
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
    closeReportProfile() {
      this.$emit("closeReportProfile");
    },
  },
};
</script>